(function () {
  function initPodInstances() {
    document.querySelectorAll('.pod-text-section:not(.pod-initialized)').forEach((textSection) => {
      textSection.classList.add('pod-initialized');

      const secId = textSection.dataset.section;
      const form = document.getElementById('product-form-' + secId);
      if (!form) return;

      // Dawn form elements
      const variantInput = form.querySelector('input[name="id"]');
      const submitBtn = form.querySelector('button[name="add"]');

      // POD elements scoped to this product section
      const colorSec = document.querySelector('.pod-color-section.pod-target-' + secId);
      const variantMap = document.querySelector('.pod-variant-map.pod-target-' + secId);
      const cycleFields = document.querySelector('.pod-cycle-fields.pod-target-' + secId);

      // Hidden Shopify line-item properties
      const dataTxt = document.querySelector('.pod-data-text.pod-target-' + secId);
      const dataCol = document.querySelector('.pod-data-color.pod-target-' + secId);
      const dataSrc = document.querySelector('.pod-data-source.pod-target-' + secId);
      const dataCycle = document.querySelector('.pod-data-cycle-length.pod-target-' + secId);
      const dataPeriod = document.querySelector('.pod-data-period-length.pod-target-' + secId);

      // Visible UI
      const uiTxt = textSection.querySelector('.pod-ui-text');
      const uiErr = textSection.querySelector('.pod-error');
      const uiCol = colorSec?.querySelector('.pod-ui-color');
      const uiHex = colorSec?.querySelector('.pod-ui-hex');
      const uiSwatch = colorSec?.querySelector('.pod-swatch');
      const uiCycle = cycleFields?.querySelector('.pod-ui-cycle-length');
      const uiPeriod = cycleFields?.querySelector('.pod-ui-period-length');
      const uiHead = document.querySelector('.pod-preview.pod-target-' + secId + ' .pod-preview-headline');
      const uiChip = document.querySelector('.pod-preview.pod-target-' + secId + ' .pod-preview-chip');

      if (!uiTxt) return;

      const customIds = (variantMap?.dataset.customVariantIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      let textWasInteractedWith = false;

      function textValue() {
        return uiTxt.value.trim();
      }

      function textIsValid() {
        return textValue().length > 0;
      }

      // We deliberately do not overwrite Dawn's native disabled state.
      // Instead, POD adds its own guard and visual state until the required
      // personalization text has been entered.
      function syncSubmitGuard() {
        if (!submitBtn) return;

        const blockedByPod = !textIsValid();
        submitBtn.classList.toggle('pod-submit-blocked', blockedByPod);

        if (blockedByPod) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.dataset.podAriaDisabled = 'true';
        } else if (submitBtn.dataset.podAriaDisabled === 'true') {
          submitBtn.removeAttribute('aria-disabled');
          delete submitBtn.dataset.podAriaDisabled;
        }
      }

      function syncText() {
        const value = textValue();

        if (dataTxt) dataTxt.value = value;

        if (uiErr) {
          uiErr.hidden = !(textWasInteractedWith && value.length === 0);
        }

        if (uiHead) {
          uiHead.textContent = value ? textSection.dataset.headline : '';
        }

        if (uiChip) {
          uiChip.textContent = value || textSection.dataset.placeholder;
        }

        syncSubmitGuard();
      }

      function syncVariant() {
        const isCustom = customIds.includes(String(variantInput?.value));

        if (colorSec) colorSec.hidden = !isCustom;
        if (dataCol) dataCol.disabled = !isCustom;
        if (dataSrc) dataSrc.disabled = !isCustom;

        syncSubmitGuard();
      }

      function syncColor() {
        if (!uiCol) return;

        const value = uiCol.value.toUpperCase();
        if (dataCol) dataCol.value = value;
        if (uiHex) uiHex.textContent = value;
        if (uiSwatch) uiSwatch.style.backgroundColor = value;
      }

      function clampNumber(input, fallback) {
        if (!input) return fallback;

        const min = Number.parseInt(input.min, 10);
        const max = Number.parseInt(input.max, 10);
        let value = Number.parseInt(input.value, 10);

        if (Number.isNaN(value)) value = fallback;
        if (!Number.isNaN(min)) value = Math.max(min, value);
        if (!Number.isNaN(max)) value = Math.min(max, value);

        input.value = String(value);
        return value;
      }

      function syncCycle(finalize = false) {
        if (!uiCycle || !dataCycle) return;

        let value = Number.parseInt(uiCycle.value, 10);
        const min = Number.parseInt(uiCycle.min, 10);
        const max = Number.parseInt(uiCycle.max, 10);

        if (finalize) {
          value = clampNumber(uiCycle, 28);
        } else if (Number.isNaN(value) || value < min || value > max) {
          return;
        }

        dataCycle.value = String(value);
      }

      function syncPeriod(finalize = false) {
        if (!uiPeriod || !dataPeriod) return;

        let value = Number.parseInt(uiPeriod.value, 10);
        const min = Number.parseInt(uiPeriod.min, 10);
        const max = Number.parseInt(uiPeriod.max, 10);

        if (finalize) {
          value = clampNumber(uiPeriod, 5);
        } else if (Number.isNaN(value) || value < min || value > max) {
          return;
        }

        dataPeriod.value = String(value);
      }

      function stepNumber(input, direction, fallback) {
        if (!input) return;

        const current = clampNumber(input, fallback);
        const step = Number.parseInt(input.step, 10) || 1;
        const min = Number.parseInt(input.min, 10);
        const max = Number.parseInt(input.max, 10);

        let next = current + direction * step;
        if (!Number.isNaN(min)) next = Math.max(min, next);
        if (!Number.isNaN(max)) next = Math.min(max, next);

        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Required name: block submission without taking ownership of Dawn's
      // availability/sold-out disabled state.
      form.addEventListener(
        'submit',
        (event) => {
          if (textIsValid()) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          textWasInteractedWith = true;
          syncText();
          uiTxt.focus();
        },
        true
      );

      uiTxt.addEventListener('input', () => {
        textWasInteractedWith = true;
        syncText();
      });

      uiTxt.addEventListener('blur', () => {
        textWasInteractedWith = true;
        syncText();
      });

      if (uiCol) {
        uiCol.addEventListener('input', syncColor);
      }

      if (uiCycle) {
        uiCycle.addEventListener('input', () => syncCycle(false));
        uiCycle.addEventListener('change', () => syncCycle(true));
        uiCycle.addEventListener('blur', () => syncCycle(true));
      }

      if (uiPeriod) {
        uiPeriod.addEventListener('input', () => syncPeriod(false));
        uiPeriod.addEventListener('change', () => syncPeriod(true));
        uiPeriod.addEventListener('blur', () => syncPeriod(true));
      }

      cycleFields?.querySelectorAll('[data-pod-stepper]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = Number.parseInt(button.dataset.direction, 10) || 0;

          if (button.dataset.podStepper === 'cycle') {
            stepNumber(uiCycle, direction, 28);
          }

          if (button.dataset.podStepper === 'period') {
            stepNumber(uiPeriod, direction, 5);
          }
        });
      });

      // Dawn-safe variant watcher. This observes the already-existing hidden
      // variant input instead of depending on translated option labels.
      if (variantInput) {
        let lastId = variantInput.value;

        new MutationObserver(() => {
          if (variantInput.value !== lastId) {
            lastId = variantInput.value;
            syncVariant();
          }
        }).observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }

      // Initial state
      syncText();
      syncVariant();
      syncColor();
      syncCycle(true);
      syncPeriod(true);
    });
  }

  // The asset can be referenced by more than one product context (for example
  // product page + quick-add). Guard the global observers so they are created
  // only once.
  if (!window.__podPersonalizationBootstrapped) {
    window.__podPersonalizationBootstrapped = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPodInstances);
    } else {
      initPodInstances();
    }

    new MutationObserver(initPodInstances).observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    initPodInstances();
  }
})();